export default {
  vessel: null,
  mode: "live",
  vesselLivePosition: null,
  vesselLiveAisInfo: null,
  vesselPictures: null,
  countryCodes: [],
  cameraSelectOptions: [],
  documentsList: null,
  voyageHistories: [],
  voyageHistoryDateTime: null,
  mapStyle: null,
  vesselPositionExpired10min: false,
  firestoreSubscribeList: [],
  kindOriginVersionMap: {},
  channelUnitMap: {},
  liveDataValueMap: {}
};
